<template>
    <div>
        <div class="mt-3">
            <div>
                <!-- tab content navigation -->
                <div class="row align-items-center">
                    <div class="col">
                        <ul
                            class="nav nav-tabs nav-tabs-alt js-tabs-enabled"
                            role="tablist"
                        >
                            <li class="nav-item">
                                <a
                                    class="nav-link active"
                                    id="personal-tab"
                                    data-toggle="tab"
                                    href="#personal"
                                    role="tab"
                                    aria-controls="personal"
                                    aria-selected="true"
                                    >Personal Data</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    id="security-tab"
                                    data-toggle="tab"
                                    href="#security"
                                    role="tab"
                                    aria-controls="security"
                                    aria-selected="false"
                                    >Security</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- end of tab content navigation -->
                <!-- tab content  -->
                <div class="tab-content" id="myTabContent">
                    <div
                        class="tab-pane fade show active"
                        id="personal"
                        role="tabpanel"
                        aria-labelledby="personal-tab"
                    >
                        <personal-component :user="user" />
                    </div>
                    <div
                        class="tab-pane fade"
                        id="security"
                        role="tabpanel"
                        aria-labelledby="security-tab"
                    >
                        <security-component />
                    </div>
                </div>
                <!-- end of tab content -->

                <!-- 2fa begins -->
                <div class="mt-3">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="block block-bordered">
                                <div class="block-header block-header-default">
                                    <span class="col-md-8">
                                        <strong>
                                            <h2 class="block-title">
                                                Two-Factor Authentication
                                            </h2>
                                        </strong>
                                    </span>
                                    <span class="col-md-4">
                                        <b
                                            class="text-danger"
                                            v-if="user.enable_2fa == '0'"
                                            >Disabled</b
                                        >
                                        <b class="text-earth" v-else>Enabled</b>
                                    </span>
                                </div>
                                <div class="block-content">
                                    <span>
                                        Two-factor authentication is a method
                                        for protecting your account. When it is
                                        activated you need to enter not only
                                        your password, but also a special code.
                                        This code will be sent to your email
                                        address.
                                    </span>
                                    <div class="mb-2 mt-2">
                                        <form
                                            @submit.prevent="
                                                toggle2fa(user.id, user)
                                            "
                                        >
                                            <button
                                                v-if="user.enable_2fa == '0'"
                                                type="submit"
                                                class="btn tridax-footer text-white"
                                            >
                                                Enable
                                            </button>
                                            <button
                                                v-else
                                                type="submit"
                                                class="btn tridax-footer text-white"
                                            >
                                                Disable
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 2fa ends -->
            </div>
        </div>
    </div>
</template>

<script>
import WalletComponent from "../../components/profile/wallet";
import SecurityComponent from "../../components/profile/security";
import PersonalComponent from "../../components/profile/personal";

import { RepositoryFactory } from "../../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");

export default {
    components: {
        WalletComponent,
        SecurityComponent,
        PersonalComponent
    },
    data() {
        return {
            twoFa: false,
            image1: "/media/avatars/avatar15.jpg",
            avatar: "/media/avatars/avatar9.jpg",
            user: ""
        };
    },
    methods: {
        toggle2fa(id, user) {
            this.twoFa = !this.twoFa;
            if (user.enable_2fa == "1") {
                let data = {
                    status: 0,
                    user: id
                };
                UsersRepository.twoFAToggle(data).then(response => {
                    Fire.$emit("Refresh");
                    toast.fire({
                        type: "success",
                        title: "Two-Factor Disabled"
                    });
                });
            } else {
                let data = {
                    status: 1,
                    user: id
                };
                UsersRepository.twoFAToggle(data).then(response => {
                    Fire.$emit("Refresh");
                    toast.fire({
                        type: "success",
                        title: "Two-Factor Enabled"
                    });
                });
            }
        },
        getUser() {
            axios.get("/api/user").then(response => {
                this.user = response.data;
            });
        }
    },
    created() {
        this.getUser();
        Fire.$on("Refresh", () => {
            this.getUser();
        });
    }
};
</script>
